import './style.scss';
import React from 'react';
import clsx from 'clsx';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import Button from '../Shared/components/controls/Button';

const OfferLocationCardComponent = ({ params, item }) => {
  //const
  const { link, title } = item.fields;
  //-->rendering
  const shouldRenderLink = !!link?.value?.href && !!link?.value?.text && link?.value?.text !== '';
  const shouldRenderEmail = !!item && item?.fields?.email?.value !== '';
  const shouldRenderEmail2 = !!item && item?.fields?.email2?.value !== '';
  const shouldRenderPhone = !!item && item?.fields?.phoneNumber?.value !== '';
  const shouldRenderPhone2 = !!item && item?.fields?.phoneNumber2?.value !== '';
  const shouldRenderTitle = !!item && item?.title?.value !== '';

  const twoColumnsPhone =
    (shouldRenderPhone || shouldRenderPhone2) && (shouldRenderEmail || shouldRenderEmail2);

  //return data
  return (
    <div className={clsx('OfferLocationCardSection', 'add-margins', params?.Styles)}>
      <div className="wrap">
        {shouldRenderTitle && (
          <div className="title">
            <Text field={title} />
            {shouldRenderLink && (
              <div className="info mobile getdirection--mobile">
                <Button link={link} />
              </div>
            )}
          </div>
        )}
        <div
          className={clsx(
            'data flex-it flex-align-item-center',
            twoColumnsPhone ? 'two-colmns' : ''
          )}
        >
          <div className="part-phone-email flex-it">
            {(shouldRenderPhone || shouldRenderPhone2) && (
              <div className="info flex-it flex-wrap">
                {shouldRenderPhone && <Phone phone={item?.fields?.phoneNumber?.value} />}
                {shouldRenderPhone2 && <Phone phone={item?.fields?.phoneNumber2?.value} />}
              </div>
            )}

            {(shouldRenderEmail || shouldRenderEmail2) && (
              <div className="info">
                {shouldRenderEmail && <Email email={item?.fields?.email?.value} />}
                {shouldRenderEmail2 && <Email email={item?.fields?.email2?.value} />}
              </div>
            )}
          </div>

          {shouldRenderLink && (
            <div className="part-buttons">
              <div className="info">
                <Button link={link} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const Email = ({ email }) => {
  return (
    <div className="info-item flex-it">
      <div className="icon flex-it flex-align-item-start">
        <img src="/-/jssmedia/Project/FAB2/shared/images/icon_email.svg" alt="" />
      </div>
      <a href={`mailto:${email}`} className="text flex-it flex-align-item-center">
        {email}
      </a>
    </div>
  );
};
const Phone = ({ phone }) => {
  return (
    <div className="info-item flex-it">
      <div className="icon flex-it flex-align-item-start">
        <img src="/-/jssmedia/Project/FAB2/shared/images/icon_phone.svg" alt="" />
      </div>
      <a href={`tel:${phone}`} className="text flex-it flex-align-item-center">
        {phone}
      </a>
    </div>
  );
};
export default OfferLocationCardComponent;
